import { UserRoles } from '@/enums';
import { RetroBonuses } from '@/modules/retro-bonuses/types';

const access_roles = {
  [RetroBonuses.Pages.RETRO_BONUSES]: [
    UserRoles.Internal.PARTNER_MANAGER, UserRoles.Internal.VICE_PARTNER_MANAGER, UserRoles.Internal.PURCHASING_MANAGER,
  ],
  [RetroBonuses.Pages.RETRO_BONUSES_REWARD_DOCUMENT]: [
    UserRoles.Internal.PARTNER_MANAGER, UserRoles.Internal.VICE_PARTNER_MANAGER, UserRoles.Internal.PURCHASING_MANAGER,
  ],
};

export default access_roles;
